export default {
      id: "huge-editor-numbered-list-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-editor-numbered-list",
      toString: function () {
        return this.url;
      }
    }